import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { UserService } from '../user/user.service';
import { SubscriptionService } from '../subscription/subscription.service';
import { ScriptLoaderService, Script } from '../helpers/script-loader.service';

declare global {
    interface Window {
        ChurnBuster: any;
    }
}

@Injectable({
    providedIn: 'root'
})
export class ChurnBusterService {
    private scriptLoaded = false;
    private readonly churnBusterScript: Script = {
        name: 'churn-buster',
        src: 'https://proxy-assets.churnbuster.io/v4/scripts.js?v=1678742553659',
        loaded: false
    };

    constructor(
        private scriptLoader: ScriptLoaderService,
        private user: UserService,
        private subscription: SubscriptionService
    ) {
    }

    get churnBusterAccountId(): string {
        return 'b8148f2b-1f77-4940-a110-ede63d7a0490';
    }

    get customerId(): string {
        return this.subscription.subscriptionData?.externalPspCustomerId || '';
    }

    get customerEmail(): string {
        return this.subscription.subscriptionData?.ownerEmail || '';
    }

    get subscriptionId(): string {
        return this.subscription.subscriptionData?.externalSubscriptionId || '';
    }

    get cancelButtonSelector(): string {
        return '[data-subscription-id]';
    }

    public initializeCancelFlow(): void {
        this.configureChurnBuster();


        this.scriptLoader.load(this.churnBusterScript).subscribe({
            next: () => {
            },
            error: (error) => {
                console.error('Failed to load Churn Buster script:', error);
            }
        });
    }

    private configureChurnBuster(): void {
        if (!window.ChurnBuster) {
            window.ChurnBuster = {};
        }

        const config = {
            accountId: this.churnBusterAccountId,
            source: 'stripe',
            customerId: this.customerId,
            customerEmail: this.customerEmail,
            cancelButtonSelector: this.cancelButtonSelector
        };

        window.ChurnBuster.cancelAttributes = config;
    }


    public isChurnBusterEnabled(): boolean {
        return environment.name === 'production';
    }
}
